export default __webpack_public_path__ + "static/Scroll-Image---Chimney-Removal-f1a8c50c67b5bec9c919fa9ea137a358.jpg";